export default __webpack_public_path__ + "static/media/cs_partial.63315d61.svg";